import { makeStyles } from '@mui/styles';
import DatePicker from 'apollo-react/components/DatePicker';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';

import { usePrevious } from '../../custom-hooks';
import { getUITA } from '../../utils/commonUtils';
import {
  DATE_FORMAT,
  EMPTY_INPUT_MASKS,
  formatDatePickerValue,
  getDatePickerConfig,
} from '../../utils/dateUtils';

const useStyles = makeStyles({
  input: {
    '& .dtInput-helperText': {
      display: 'none',
    },
    '& .rdtPicker': {
      marginTop: -57,
    },
    '& .dtInput-invalid': {
      border: '1px solid #d9d9d9 !important',

      '&:hover': {
        borderColor: '#0768fd',
      },
    },
  },
});

function DatePickerFilter({ accessor, filters, updateFilterValue }) {
  const classes = useStyles();

  const ref = useRef();
  const [inputValue, setInputValue] = useState(filters[accessor] || '');

  const prevInputValue = usePrevious(inputValue);

  const { mask, dateFormat, dateValue } = getDatePickerConfig(filters?.[accessor], inputValue);

  const isValidDate =
    inputValue === '' || (!inputValue.includes('_') && moment(inputValue, dateFormat).isValid());

  const handleValueChange = (date, dateValue) => {
    if (moment.isMoment(date) || (dateValue === '' && dateValue !== prevInputValue)) {
      const formattedDateValue =
        dateValue === '' || EMPTY_INPUT_MASKS.includes(dateValue)
          ? ''
          : formatDatePickerValue(date);

      setInputValue(formattedDateValue);

      const e = new Event('change', {});
      ref.current.value = formattedDateValue;
      ref.current.dispatchEvent(e);
      ref.current.blur();
      updateFilterValue(e);
    }
  };

  const handleInputChange = (newInputValue) => {
    if (newInputValue !== inputValue) {
      EMPTY_INPUT_MASKS.includes(newInputValue) ? setInputValue('') : setInputValue(newInputValue);
    }
  };

  useEffect(() => {
    setInputValue(filters[accessor] || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters?.[accessor]]);

  return (
    <DatePicker
      inputProps={{
        ref,
        name: accessor,
        autoComplete: 'off',
        style: { width: 140 },
      }}
      TextFieldProps={{
        name: accessor,
        style: { marginTop: 0 },
      }}
      size="small"
      inputValue={inputValue}
      name={accessor}
      mask={mask}
      maskPlaceholder="_"
      dateFormat={dateFormat}
      defaultValue={moment()}
      value={dateValue}
      onInputChange={handleInputChange}
      error={!isValidDate}
      className={classes.input}
      placeholder={DATE_FORMAT}
      onChange={handleValueChange}
      PopperProps={{
        'ui-ta': getUITA('datepicker-popup'),
        disablePortal: false,
      }}
      TodayButtonProps={{
        'ui-ta': getUITA('today-button'),
      }}
    />
  );
}

export default DatePickerFilter;
